export enum ShopifyBasicDiscountCustomerEligibility {
  All = "all",
  Segments = "segments",
  Specific = "specific",
}
